import React, { forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import ListContext from '../List/ListContext';
import styles from './ListItemAvatar.module.css';

const ListItemAvatar = forwardRef(function ListItemAvatar(props, ref) {
  const { className, ...other } = props;
  const context = React.useContext(ListContext);

  return (
    <div
      className={cn(
        styles.root,
        {
          [styles.alignItemsFlexStart]: context.alignItems === 'flex-start',
        },
        className,
      )}
      ref={ref}
      {...other}
    />
  );
});

/* eslint-disable */
ListItemAvatar.propTypes = {
  children: Type.element.isRequired,
  className: Type.string,
};
/* eslint-enable */

export default ListItemAvatar;
